import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import { Crown } from 'lucide-react';

export default function AuthCallback() {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');
    const errorParam = params.get('error');

    if (errorParam) {
      setError(errorParam);
      toast.error('Authentication failed: ' + errorParam);
      setTimeout(() => navigate('/auth'), 2000);
      return;
    }

    if (sessionId) {
      handleSession(sessionId);
    } else {
      setError('No session found');
      setTimeout(() => navigate('/auth'), 2000);
    }
  }, []);

  const handleSession = async (sessionId) => {
    try {
      const result = await exchangeSession(sessionId);
      toast.success('Welcome to Mystic Reels!');
      
      const role = result.user?.role;
      if (['admin', 'moderator', 'support'].includes(role)) {
        navigate('/admin');
      } else if (role === 'staff') {
        navigate('/agent-portal');
      } else {
        navigate('/app');
      }
    } catch (err) {
      const msg = err.response?.data?.detail || 'Authentication failed';
      setError(typeof msg === 'string' ? msg : JSON.stringify(msg));
      toast.error('Authentication failed');
      setTimeout(() => navigate('/auth'), 2000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#0B0E14' }}>
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-[#D4AF37]/20 flex items-center justify-center animate-pulse">
            <Crown className="w-8 h-8 text-[#D4AF37]" />
          </div>
        </div>
        {error ? (
          <>
            <h2 className="text-xl font-bold text-red-400 mb-2">Authentication Error</h2>
            <p className="text-gray-400">{error}</p>
            <p className="text-sm text-gray-500 mt-2">Redirecting...</p>
          </>
        ) : (
          <>
            <div className="spinner mx-auto mb-4" />
            <h2 className="text-xl font-semibold">Authenticating...</h2>
            <p className="text-gray-400 text-sm mt-2">Please wait while we sign you in</p>
          </>
        )}
      </div>
    </div>
  );
}
